export var ContractOnboardingStatus;
(function (ContractOnboardingStatus) {
    ContractOnboardingStatus["CONTRACT_SIGNED"] = "CONTRACT_SIGNED";
    ContractOnboardingStatus["MANUAL_UNDERWRITING_INITIATED"] = "MANUAL_UNDERWRITING_INITIATED";
    ContractOnboardingStatus["MISSING_ADDITIONAL_DATA"] = "MISSING_ADDITIONAL_DATA";
    ContractOnboardingStatus["ONBOARDING_COMPLETED"] = "ONBOARDING_COMPLETED";
    ContractOnboardingStatus["PENDING"] = "PENDING";
    ContractOnboardingStatus["SUSPENDED"] = "SUSPENDED";
    ContractOnboardingStatus["TERMINATED"] = "TERMINATED";
    ContractOnboardingStatus["UNDERWRITING_APPROVED"] = "UNDERWRITING_APPROVED";
    ContractOnboardingStatus["UNDERWRITING_INITIATED"] = "UNDERWRITING_INITIATED";
})(ContractOnboardingStatus || (ContractOnboardingStatus = {}));
